export const CALL_API = 'palliative-care/CALL_API';



// WEBPACK FOOTER //
// ./src/lib/dataLayer/constants.js